import React from 'react';
import { Box, Card, CardContent, Divider, MenuItem, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';

import { STATUS_OPTIONS } from './approvalWorkflowConstants';
import { formatDate } from './approvalWorkflowFormatters';

export default function ApprovalRequestsCard({ requests, statusFilter, onStatusFilterChange }) {
    return (
        <Card>
            <CardContent>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ md: 'center' }}>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Alle Freigaben
                    </Typography>
                    <TextField
                        select
                        label="Status filtern"
                        value={statusFilter}
                        onChange={onStatusFilterChange}
                        SelectProps={{ multiple: true, renderValue: (selected) => selected.join(', ') }}
                        size="small"
                    >
                        {STATUS_OPTIONS.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Stack>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Typ</TableCell>
                                <TableCell>Referenz</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Erstellt von</TableCell>
                                <TableCell>Entscheider</TableCell>
                                <TableCell>Kommentar</TableCell>
                                <TableCell>Entscheidungsnotiz</TableCell>
                                <TableCell>Erstellt am</TableCell>
                                <TableCell>Entschieden am</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {requests.map((item) => (
                                <TableRow key={item.id}>
                                    <TableCell>{item.type}</TableCell>
                                    <TableCell>{item.targetId}</TableCell>
                                    <TableCell>{item.status}</TableCell>
                                    <TableCell>{item.creatorName || item.creatorId}</TableCell>
                                    <TableCell>{item.approverName || item.approverId || '-'}</TableCell>
                                    <TableCell>{item.comment || '-'}</TableCell>
                                    <TableCell>{item.decisionComment || '-'}</TableCell>
                                    <TableCell>{formatDate(item.createdAt)}</TableCell>
                                    <TableCell>{formatDate(item.decidedAt)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </CardContent>
        </Card>
    );
}
